import { MantineThemeOverride } from '@mantine/core';

export type BadgeTheme = NonNullable<MantineThemeOverride['components']>['Badge'];

export const Badge: BadgeTheme = {
  // todo: define
};
